import { render, staticRenderFns } from "./CoreBomImportTable.vue?vue&type=template&id=2c94db81"
import script from "./CoreBomImportTable.vue?vue&type=script&lang=js"
export * from "./CoreBomImportTable.vue?vue&type=script&lang=js"
import style0 from "./CoreBomImportTable.vue?vue&type=style&index=0&id=2c94db81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CoreBomImportTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports